import { RootPaths } from "@src/appV2/App/paths";
import { ShiftDiscoverySearchMode } from "@src/appV2/OpenShifts/ShiftAction/api/useClaimShift";

import { SHIFT_DISCOVERY_LIST_PATH, SHIFT_DISCOVERY_MAP_PATH } from "./paths";

export const DEFAULT_SHIFT_DISCOVERY_SEARCH_MODE = ShiftDiscoverySearchMode.LIST;

export function getBaseModalsNavigationPath(
  searchMode: ShiftDiscoverySearchMode | undefined
): string {
  return (searchMode ?? DEFAULT_SHIFT_DISCOVERY_SEARCH_MODE) === ShiftDiscoverySearchMode.LIST
    ? `${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}`
    : `${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_MAP_PATH}`;
}
